export interface InventAuctionLot {
  id: string;
  auctionId: string;
  vehicleId?: string;
  vrm: string;
  vin: string;
  manufacturer: string;
  model: string;
  variant: string;
  year: number | null;
  mileage: number | null;
  bodyType: string;
  colour: string;
  fuelType: string;
  transmission: string;
  reservePrice: number | null;
  currentBid: number | null;
  status: number;
  statusText: string;
  auctionTitle: string;
  auctionDateTime: Date | null;
  defaultImageUrl: string;
  imageUrls: string[];
  processedDate: Date | null;
  soldDate: Date | null;
  recentlySold: boolean;
  endDateTime?: Date;
  advertId?: string;
  importTextError?: string;
  added?: Date;
  updated?: Date;
}

export enum AuctionLotStatus {
  Unknown = 0,
  Available = 1,
  Imported = 2,
  Provisional = 3,
  Actioned = 4,
  Withdrawn = 5,
  Error = 6
}

export function getStatusText(status: number): string {
  switch (status) {
    case AuctionLotStatus.Available:
      return 'Available';
    case AuctionLotStatus.Imported:
      return 'Imported';
    case AuctionLotStatus.Provisional:
      return 'Provisional';
    case AuctionLotStatus.Actioned:
      return 'Actioned';
    case AuctionLotStatus.Withdrawn:
      return 'Withdrawn';
    case AuctionLotStatus.Error:
      return 'Deleted';
    default:
      return 'Unknown';
  }
}
